import { useEffect, useRef } from "react";
import { DocArchive } from "../../axios";
import { DbUtils } from "../../utils/DbUtils";
import { ErrorUtils } from "../../utils/ErrorUtils";

interface Props {

	/** 文書アーカイブ */
	archive: DocArchive,

	/** 確定時処理 */
	onCommit: (archive: DocArchive) => void,

	/** キャンセル時処理 */
	onCancel: () => void,
};

/**
 * 送信履歴一覧用コンポーネント
 * 
 * @returns 
 */
export default function ArchiveEdit(props: Props): JSX.Element {

	/** 取引先 */
	const customer = useRef<HTMLInputElement | null>(null);

	/** 文書名 */
	const doc_name = useRef<HTMLInputElement | null>(null);

	/** 金額 */
	const amount = useRef<HTMLInputElement | null>(null);

	/** 検索キー１ */
	const search_key_1 = useRef<HTMLInputElement | null>(null);

	/** 検索キー２ */
	const search_key_2 = useRef<HTMLInputElement | null>(null);

	/** 検索キー３ */
	const search_key_3 = useRef<HTMLInputElement | null>(null);

	// 初回のみ実行
	useEffect(() => {
		customer.current!.value = props.archive.customer || '';
		doc_name.current!.value = props.archive.doc_name || '';
		amount.current!.value = String(props.archive.amount || '');
		search_key_1.current!.value = props.archive.search_key_1 || '';
		search_key_2.current!.value = props.archive.search_key_2 || '';
		search_key_3.current!.value = props.archive.search_key_3 || '';
	}, []);

	/**
	 * 確定ボタンクリック時イベント
	 */
	const handleCommitClick = async () => {
		try {

			if (amount.current!.value != '' && isNaN(Number(amount.current!.value))) {
				alert('金額には数字を入力してください。');
				return;
			}

			props.archive.customer = customer.current!.value;
			props.archive.doc_name = doc_name.current!.value;
			props.archive.amount = amount.current!.value == '' ? undefined : Number(amount.current!.value);
			props.archive.search_key_1 = search_key_1.current!.value;
			props.archive.search_key_2 = search_key_2.current!.value;
			props.archive.search_key_3 = search_key_3.current!.value;

			await DbUtils.getArchiveApi().updateArchive(props.archive._id!, props.archive);
			props.onCommit(props.archive);
		} catch (error) {
			ErrorUtils.alert(error);
		}
	};

	/**
	 * キャンセルボタンクリック時イベント
	 */
	const handleCancelClick = async () => {
		props.onCancel();
	};

	// 描画する
	return (
		<div className="dialog">
			<div className="dialog-contents">
				<h4>送信履歴修正</h4>
				<hr />
				<div className="control-group">
					<div>
						<table width="100%" className="hyosearch">
							<tbody>
								<tr>
									<td scope="row">取引先</td>
									<td scope="row" colSpan={3}>
										<div>
											<input type="text" name="customer" size={35} ref={customer} maxLength={256} />
										</div>
									</td>
								</tr>
								<tr>
									<td scope="row">文書名</td>
									<td scope="row" colSpan={3}>
										<div>
											<input type="text" name="doc_name" size={35} ref={doc_name} maxLength={256} />
										</div>
									</td>
								</tr>
								<tr>
									<td scope="row">金額</td>
									<td scope="row" colSpan={3}>
										<div>
											<input type="text" name="amount" size={35} ref={amount} maxLength={15} />
										</div>
									</td>
								</tr>
								<tr>
									<td scope="row">検索キー１</td>
									<td scope="row" colSpan={3}>
										<div>
											<input type="text" name="search_key_1" size={35} ref={search_key_1} maxLength={256} />
										</div>
									</td>
								</tr>
								<tr>
									<td scope="row">検索キー２</td>
									<td scope="row" colSpan={3}>
										<div>
											<input type="text" name="search_key_2" size={35} ref={search_key_2} maxLength={256} />
										</div>
									</td>
								</tr>
								<tr>
									<td scope="row">検索キー３</td>
									<td scope="row" colSpan={3}>
										<div>
											<input type="text" name="search_key_3" size={35} ref={search_key_3} maxLength={256} />
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<hr />
				<div className="control-group">
					<div className="controls">
						<button className="btn btn-default btn-primary pull-center" type="button" onClick={handleCommitClick}>確定</button>
						&nbsp;
						<button className="btn btn-default btn-secondary pull-center" type="button" onClick={handleCancelClick}>キャンセル</button>
					</div>
				</div>
			</div>
		</div>
	);
}